import Component from "../../lib/component";
import iconDownObtuseChevron from "./assets/icon__down_obtuse_chevron.svg";

export const PaneSlidesBackButtonConfig = {
    componentTypeKey: 'PaneSlidesBackButton',
    baseHtmlClass: 'pane_slides__bb',
    selector: '.pane_slides__bb',
};

export class PaneSlidesBackButton extends Component {

    static createElement(parentElement) {
        const element = Component.createElement(PaneSlidesBackButton.config.baseHtmlClass, { tagName: 'a' });
        element.setAttribute('title', 'Back to start');
        const svgElement = new DOMParser().parseFromString(
            iconDownObtuseChevron,
            "image/svg+xml",
        ).documentElement;
        svgElement.style.cssText = "display:block;height:100%;width:100%;";
        element.appendChild(svgElement);
        parentElement.appendChild(element);
        return element;
    }

    static get config() {
        return PaneSlidesBackButtonConfig;
    }

    constructor(id_or_element, paneSlides) {
        super({
            element: id_or_element,
            config: PaneSlidesBackButton.config
        });

        this.paneSlides = paneSlides;

        this.element.addEventListener('click', this.handleClick.bind(this));
    }

    handleClick(event) {
        if (this.paneSlides) {
            event.preventDefault();
            this.paneSlides.goBack();
        }
    }

    render() {
        this.conditionallySetHtmlClassState(this.paneSlides.isFocusedOnFirstSlide(), 'not_needed');
    }

}